import React from 'react';
import PropTypes from 'prop-types';
import { StatWidget } from './StatWidget';
import { StackedBarWidget } from './StackedBarWidget';
import { BarWidget } from './BarWidget';
import { BarPercentageWidget } from './BarPercentageWidget';
import { WIDGET_TYPES } from './widgetTypes';

export const DynamicWidget = ({ widget }) => {
  switch (widget.type) {
    case WIDGET_TYPES.STAT:
      return <StatWidget widget={widget} />;
    case WIDGET_TYPES.STACKED_BAR:
      return <StackedBarWidget widget={widget} />;
    case WIDGET_TYPES.BAR:
      return <BarWidget widget={widget} />;
    case WIDGET_TYPES.BAR_PERCENTAGE:
      return <BarPercentageWidget widget={widget} />;
    default:
      return null;
  }
};

DynamicWidget.propTypes = {
  widget: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};
